export default "__VITE_ASSET__ATrT5uwy__"